import React, { createRef } from 'react';
import moment from 'moment';
import Service from '../../../config/networkutils';
import { getCookie } from '../../../utils/CookieHelper';
import RolesEmployeeLocation from './RolesEmployeeLocation';
import { CoffeeLoading, LoopCircleLoading, RotateCircleLoading } from 'react-loadingg';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Slide } from '@material-ui/core';
import { withSnackbar } from 'notistack';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Typography from '@material-ui/core/Typography';
import { getCRMTableData, getDiscipline, getEmployeeRegionWithHistory, getOtherTasks, } from '../../../config/PromisesHandler';
import { DatePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ZoomIn from '@material-ui/icons/ZoomIn';
import ZoomOut from '@material-ui/icons/ZoomOut';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import UserAllocation from '../../UserAllocation/UserAllocation';
import CloseIcon from '@material-ui/icons/Close';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { CircularProgress, Grid } from '@mui/material';
import { getDataIsdeletedFalse, getPrimaryColor, screenSizeCheck } from '../../Helper/CommonThings';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const months = { 0: 'January', 1: 'Febrauary', 2: 'March', 3: 'April', 4: 'May', 5: 'June', 6: 'July', 7: 'August', 8: 'September', 9: 'October', 10: 'November', 11: 'December' }
const token = getCookie("ptd_ts_token");
const user = JSON.parse(getCookie("ptd_ts_user"));

const initialBulkUpdateState = {
    employee: null,
    fromDate: null,
    toDate: null,
    taskCategory: '',
    comments: '',
    quantity: '1'
}

class ResourceLocationResults extends React.Component {
    constructor(props) {
        super(props)
        this.topRef = createRef()
        this.state = {
            scrollTop: false
        }
    }

    scrolltoTop = () => {
        if (this.topRef.current) {
            this.topRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    handleScroll = (e) => {
        const isScrolled = e.target.scrollTop > 50
        if (isScrolled !== this.state.scrollTop) {
            this.setState({ scrollTop: isScrolled })
        }
    }

    render() {
        const { isLoading1, responseData, splittedRoleEmployees, zoom, selectedStartDate,
            selectedEndDate, rolesObj, disciplineObj, projectObj, reportedRoles, allOtherTasks,
            othertaskObject, allProjects, allRoles, liveOpportunities, updateTheUpdatedSchedules, addAllocation, type, handleRefresh, roleContainerHeight } = this.props

        if (isLoading1) {
            return <LoopCircleLoading color={getPrimaryColor()} />
        }

        if (responseData.length === 0) {
            return splittedRoleEmployees.length > 0 ? <Typography style={{ textAlign: 'center' }}>No report available for the selected Options</Typography> : null
        }

        if (splittedRoleEmployees.length === 0) {
            return null
        }

        return (
            <div>
                <div
                    ref={this.topRef}
                    style={{ maxHeight: roleContainerHeight, overflowY: 'scroll' }}
                    onScroll={this.handleScroll}
                >
                    {splittedRoleEmployees.map((role, roleIndex) => (
                        <div key={roleIndex} style={{ zoom }}>
                            <RolesEmployeeLocation
                                disciplineObj={disciplineObj}
                                selectedStartDate={selectedStartDate}
                                selectedEndDate={selectedEndDate}
                                rolesObj={rolesObj}
                                refreshData={handleRefresh}
                                roleData={splittedRoleEmployees[roleIndex]}
                                projectObj={projectObj}
                                role={reportedRoles[roleIndex]}
                                templateRoles={responseData}
                                allOtherTasks={allOtherTasks}
                                othertaskObject={othertaskObject}
                                allProjects={allProjects}
                                allRoles={allRoles}
                                liveOpportunities={liveOpportunities}
                                updateTheUpdatedSchedules={updateTheUpdatedSchedules}
                                addAllocation={addAllocation}
                                type={type}
                            />
                        </div>
                    ))}
                </div>
                {this.state.scrollTop ? <IconButton size='large' onClick={this.scrolltoTop} variant='contained' style={{ zIndex: 999, position: 'absolute', right: 40, bottom: 40 }}><ArrowUpwardIcon style={{ fontSize: '40px' }} /></IconButton> : null}
            </div>
        )
    }
}

class ResourceLocation extends React.Component {
    constructor() {
        super()
        this.state = {
            allRoles: [],
            rolesObj: {},
            allEmp: [],
            allEmpRegionHistory: [],
            regionObj: {},
            isLoading: true,
            isLoading1: false,
            allProjects: [],
            responseData: [],
            projectObj: {},
            selectedRole: [],
            rolesData: [],
            searchRerenders: false,
            allSubSectors: [],
            selectedSubSector: [],
            allOwnerRegions: [],
            selectedOwnerRegion: [],
            allOwnerDeliveryUnits: [],
            selectedOwnerDelivery: [],
            showRole: false,
            showRoleIndex: null,
            selectedCrm: { name: '', id: '' },
            selectedEmployee: { first_name: 'Select Employee', last_name: '', id: '' },
            splittedRoleEmployees: [],
            selectedStartDate: moment().subtract(1, 'months').startOf('month'),
            selectedEndDate: moment().add(6, 'months').endOf('month'),
            allocationDialog: false,
            allocationDialogSize: 'xs',
            allocationData: null,
            toggleView: 'role',
            addEmpDisabled: false,
            type: 'week',
            zoom: 1,
            roleGroup: [],
            selectedRoleGroup: [],
            scrollTop: false,
            selectedRoleGrp: [],
            coffeeLoading: false,
            disciplineObj: {},
            allDivisions: [],
            selectedDivision: [],
            bulkUpdateDialog: false,
            bulkUpdate: { ...initialBulkUpdateState },
            bulkLoading: false,
        }
        this.topRef = createRef()
        this.handleRefresh = this.handleRefresh.bind(this);
        this.getDialogSize = this.getDialogSize.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.addAllocation = this.addAllocation.bind(this);
    }

    editedScheduleUIUpdate = (empArray) => {
        // Filter the response data based on the employee
        let allRoleEmployeess = [...this.state.responseData];
        for (let crmIndex = 0; crmIndex < allRoleEmployeess.length; crmIndex++) {
            for (let empIndex = 0; empIndex < empArray.length; empIndex++) {
                if ((allRoleEmployeess[crmIndex].crm === empArray[empIndex].crm) && (allRoleEmployeess[crmIndex].emp_id === empArray[empIndex].emp_id)) {
                    allRoleEmployeess[crmIndex] = empArray[empIndex];
                }
            }
        }
        this.setState({
            ...this.state,
            allRoleEmployees: allRoleEmployeess,
        });
    };

    getProjectsEmployees() {
        this.setState({ isLoading: true, isLoading1: true, addEmpDisabled: true, })

        let roles_crm_emp_id = ''

        if (this.state.type === 'week') {
            roles_crm_emp_id = '/api/prp/rolenew/get_staff_location_data/?archive_reason=0&'
        } else if (this.state.type === 'month') {
            roles_crm_emp_id = '/api/prp/rolenew/get_staff_location_data/?archive_reason=0&change_report_type=month&'
        } else if (this.state.type === 'quarter') {
            roles_crm_emp_id = '/api/prp/rolenew/get_staff_location_data/?archive_reason=0&change_report_type=quarter&'
        }

        let selectedRoleGrpIds = [];
        this.state.selectedRoleGrp.forEach((rg) => {
            selectedRoleGrpIds.push(rg.id);
        });

        if (this.state.selectedCrm?.id) {
            let allocationData = { prj: { crm: this.state.selectedCrm.id, crm_name: this.state.selectedCrm.name } }
            this.setState({ allocationData })
            roles_crm_emp_id = roles_crm_emp_id + `crm=${this.state.selectedCrm.id}&`
        }
        if (this.state.selectedEmployee?.id) {
            roles_crm_emp_id = roles_crm_emp_id + `emp=${this.state.selectedEmployee.id}&`
        }

        if (selectedRoleGrpIds.length > 0) {
            roles_crm_emp_id = roles_crm_emp_id + `role_group=${selectedRoleGrpIds.join(',')}&`
        }

        if (this.state.selectedStartDate && this.state.selectedEndDate) {
            roles_crm_emp_id = roles_crm_emp_id + `from_date=${moment(this.state.selectedStartDate).format('YYYY-MM-DD')}&to_date=${moment(this.state.selectedEndDate).format('YYYY-MM-DD')}`
        }

        roles_crm_emp_id += `&is_active=True`

        Service.get(roles_crm_emp_id, {
            headers: { Authorization: "Token " + token, }
        })
            .then(res => {
                let rolesss;

                if (this.state.selectedRole.length === 0) {
                    rolesss = [...this.state.allRoles]
                } else {
                    rolesss = [...this.state.selectedRole]
                }
                this.setState({
                    reportedRoles: rolesss,
                    responseData: res.data.data,
                    // isLoading: false,
                    // isLoading1: false,
                    addEmpDisabled: this.state.selectedEmployee?.id ? true : false,
                }, () => this.makeReport(res.data.data, res.data.all_dates, this.state.type))
            }).catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' })
                this.setState({ isLoading: false, isLoading1: false })
            })
    }

    getDropdownData() {
        return new Promise((resolve, reject) => {
            Service.get('/api/roles/get_default_data/', {
                headers: {
                    Authorization: "Token " + token,
                },
            })
                .then(res => {
                    res.data.roles = getDataIsdeletedFalse(res.data.roles)
                    res.data.owner_region_sector = getDataIsdeletedFalse(res.data.owner_region_sector)
                    res.data.sub_sector = getDataIsdeletedFalse(res.data.sub_sector)
                    res.data.owner_delivery = getDataIsdeletedFalse(res.data.owner_delivery)
                    res.data.role_group = getDataIsdeletedFalse(res.data.role_group)
                    res.data.division = getDataIsdeletedFalse(res.data.division)
                    resolve(res.data)
                })
                .catch(error => reject(error))
        })
    }

    componentDidMount() {
        Promise.all([
            this.getDropdownData(),
            getEmployeeRegionWithHistory(),
            getCRMTableData(),
            getOtherTasks(),
            // getEmployeesLeaves(),
            getDiscipline()
        ])
            .then(res => {
                let data = res[0].roles

                let rolesobj = {}
                data.forEach(ele => {
                    let newData = { [ele.id]: ele.job_roles }
                    rolesobj = { ...rolesobj, ...newData }
                })

                let regionObj = {}
                res[0].owner_region_sector.forEach(ele => {
                    let newData = { [ele.id]: ele.name }
                    regionObj = { ...regionObj, ...newData }
                })

                let projectObj = {}
                res[0].crm.forEach(ele => {
                    let newData = { [ele.id]: { project_code: ele.project_code, name: ele.name } }
                    projectObj = { ...projectObj, ...newData }
                })

                let othertaskObject = {}
                res[3].forEach(ele => {
                    let newData = { [ele.id]: ele.name }
                    othertaskObject = { ...othertaskObject, ...newData }
                })

                let disciplineObj = {}
                res[4].forEach(ele => {
                    let newData = { [ele.id]: ele.name }
                    disciplineObj = { ...disciplineObj, ...newData }
                })

                this.setState({
                    rolesObj: rolesobj,
                    allRoles: res[0].roles,
                    allEmp: res[0].employees,
                    allEmpRegionHistory: res[1],
                    allOwnerRegions: res[0].owner_region_sector,
                    regionObj: regionObj,
                    allProjects: res[0].crm,
                    projectObj: projectObj,
                    isLoading: false,
                    completedOppertunities: res[2],
                    allSubSectors: res[0].sub_sector,
                    allOwnerDeliveryUnits: res[0].owner_delivery,
                    allDivisions: res[0].division,
                    // allMarketSubVerticles:3,
                    // rolesData:res[0]
                    allOtherTasks: res[3],
                    othertaskObject,
                    liveOpportunities: res[0].crm,
                    roleGroup: res[0].role_group,
                    disciplineObj: disciplineObj
                }, () => {

                    let searchParams = new URLSearchParams(window.location.search)
                    let selectedRoles = []
                    let selectedRegions = []
                    let selectedSubSectors = []
                    let selectedOwnerDeliverys = []
                    let selectedCrm = []
                    let selectedEmployee = []
                    let selectedRoleGroup = []
                    let selectedRoleGrp = []

                    if (searchParams.get("role")) {
                        let idNum = searchParams.get("role").split(',')
                        for (let id = 0; id < idNum.length; id++) {
                            let perRole = this.state.allRoles.filter((rol) => rol.id === parseInt(idNum[id]))
                            selectedRoles.push(perRole[0])
                        }
                    }
                    if (searchParams.get("selectedOwnerRegion")) {
                        let idNum = searchParams.get("selectedOwnerRegion").split(',')
                        for (let id = 0; id < idNum.length; id++) {
                            let perRegion = this.state.allOwnerRegions.filter((regio) => regio.id === parseInt(idNum[id]))
                            selectedRegions.push(perRegion[0])
                        }
                    }
                    if (searchParams.get("selectedSubSector")) {
                        let idNum = searchParams.get("selectedSubSector").split(',')
                        for (let id = 0; id < idNum.length; id++) {
                            let perSector = this.state.allSubSectors.filter((secto) => secto.id === parseInt(idNum[id]))
                            selectedSubSectors.push(perSector[0])
                        }
                    }
                    if (searchParams.get("selectedOwnerDelivery")) {
                        let idNum = searchParams.get("selectedOwnerDelivery").split(',')
                        for (let id = 0; id < idNum.length; id++) {
                            let perODU = this.state.allOwnerDeliveryUnits.filter(odu => odu.id === parseInt(idNum[id]))
                            selectedOwnerDeliverys.push(perODU[0])
                        }
                    }

                    if (searchParams.get("roleGroup")) {
                        let idNum = searchParams.get("roleGroup").split(',')
                        for (let id = 0; id < idNum.length; id++) {
                            let perRoleGroup = this.state.roleGroup.filter(rg => rg.id === parseInt(idNum[id]))
                            selectedRoleGroup.push(perRoleGroup[0])
                        }
                    }

                    if (searchParams.get("crm")) {
                        let idNum = searchParams.get("crm")
                        selectedCrm = this.state.allProjects.filter(crm => crm.id === parseInt(idNum))[0]
                    }


                    if (searchParams.get("roleGrp")) {
                        let idNum = searchParams.get("roleGrp").split(',')
                        for (let id = 0; id < idNum.length; id++) {
                            let perRoleGroup = this.state.roleGroup.filter(rg => rg.id === parseInt(idNum[id]))
                            selectedRoleGrp.push(perRoleGroup[0])
                        }
                    }

                    if (searchParams.get("employee")) {
                        let idNum = searchParams.get("employee")
                        selectedEmployee = this.state.allEmp.filter(emp => emp.id === parseInt(idNum))[0]
                    } else {
                        selectedEmployee = { first_name: 'Select Employee', last_name: '', id: '' }
                    }


                    if (selectedCrm.name || selectedEmployee.id || selectedRoleGrp.length > 0) {
                        this.setState({
                            selectedRoleGrp, selectedRole: selectedRoles, selectedCrm, selectedEmployee, isLoading: true, toggleView: 'crm'
                        }, () => {
                            this.getProjectsEmployees()
                            if (this.props.changeViewParent) {
                                this.props.changeViewParent('crm')
                            }
                        })
                    } else if (selectedRoles.length > 0 ||
                        selectedRegions.length > 0 ||
                        selectedSubSectors.length > 0 ||
                        selectedOwnerDeliverys.length > 0 || selectedRoleGroup.length > 0) {
                        this.setState({
                            selectedRole: selectedRoles, selectedOwnerRegion: selectedRegions
                            , selectedSubSector: selectedSubSectors, selectedOwnerDelivery: selectedOwnerDeliverys, selectedRoleGroup, toggleView: 'role'
                        }, () => {
                            this.fetchOps()
                            if (this.props.changeViewParent) {
                                this.props.changeViewParent('role')
                            }
                        })
                    }
                })
            })
            .catch(e => {
                console.log(e)
                this.props.enqueueSnackbar('Something went wrong. Please try again later.', {
                    variant: 'error'
                });
            })

    }

    handleRefresh() {
        this.componentDidMount()
    }

    makeReport(allRoles, datesArray, type) {

        let reportedRoles = []
        let templateRoles = []
        let splittedRoleEmployees = []
        let finalColumns = []
        let allMonths = []

        for (let index = 0; index < allRoles.length; index++) {
            const element = allRoles[index];

            const startOfMonth = this.state.selectedStartDate ? moment(this.state.selectedStartDate).startOf('month') : moment().subtract(2, 'months').startOf('month');
            const endOfMonth = this.state.selectedEndDate ? moment(this.state.selectedEndDate).endOf('month') : moment().add(6, 'months').endOf('month');

            let startDate = moment(startOfMonth)
            let endDate = moment(endOfMonth)

            let result = [];

            if (endDate.isBefore(startDate)) {
                throw new Error("End date must be greater than start date.")
            }

            while (startDate.isBefore(endDate)) {
                result.push(months[startDate.month()] + ' ' + startDate.year());
                startDate.add(1, 'month');
            }

            // let allWeekDates = weekStartDates(startOfMonth, endOfMonth);

            let final = []
            let colspan = 1;
            if (type === 'week') {
                for (let i = 0; i < datesArray.length; i++) {
                    let date = moment(datesArray[i], 'DD/MM/YYYY')
                    let monthYear = months[date.month()] + ' ' + date.year()
                    if (!result.length) {
                        result.push(monthYear)
                        final.push({ month: monthYear, colSpan: colspan })
                    }
                    else {
                        if (result[result.length - 1] === monthYear) {
                            colspan += 1
                            final[final.length - 1]['colSpan'] = colspan
                        }
                        else {
                            colspan = 1
                            result.push(monthYear)
                            final.push({ month: monthYear, colSpan: colspan })
                        }
                    }

                }
            } else if (type === 'month') {
                for (let i = 0; i < datesArray.length; i++) {
                    let date = moment(datesArray[i])
                    if (final.map((ele) => ele.month).indexOf(date.year()) === -1) {
                        final.push({ month: date.year(), colSpan: 1 })
                    } else {
                        final[final.map((ele) => ele.month).indexOf(date.year())]['colSpan'] += 1
                    }

                }

            } else {
                for (let i = 0; i < datesArray.length; i++) {
                    let year = datesArray[i].split('-')[1]
                    if (final.map((ele) => ele.month).indexOf(year) === -1) {
                        final.push({ month: year, colSpan: 1 })
                    } else {
                        final[final.map((ele) => ele.month).indexOf(year)]['colSpan'] += 1
                    }

                }
            }
            for (let index = 0; index < final.length; index++) {
                const element = final[index];
                element.width = 150 * element.colSpan
            }

            allMonths = final

            reportedRoles.push(this.state.reportedRoles.filter((ele) => ele.id === element.role_id)[0])

            let disciplineDateObj = {}

            for (let m = 0; m < datesArray.length; m++) {
                let date = datesArray[m]
                for (let i = 0; i < element.project_details.length; i++) {
                    let roleItem = element.project_details[i];
                    for (let index = 0; index < roleItem.role_schedule.length; index++) {
                        const element1 = roleItem.role_schedule[index];
                        let fromDateSplit = moment(element1.from).format('DD/MM/YYYY').split('/')
                        let toDateSplit = moment(element1.to).format('DD/MM/YYYY').split('/')
                        let fromDate = new Date(fromDateSplit[2], parseInt(fromDateSplit[1]) - 1, fromDateSplit[0])
                        let toDate = new Date(toDateSplit[2], parseInt(toDateSplit[1]) - 1, toDateSplit[0])
                        let dateString = date
                        let dateParts = dateString.split("/");
                        // month is 0-based, that's why we need dataParts[1] - 1
                        let dateObj = new Date(dateParts[2], parseInt(dateParts[1]) - 1, dateParts[0]);
                        let dateObject = new Date(dateObj)
                        if (dateObject >= fromDate && dateObject <= toDate) {
                            disciplineDateObj[date] = this.state.disciplineObj[element1.discipline]
                            break;
                        }
                    }
                }
            }


            let weeks = [];
            let weekdata = [];
            for (let i = 0; i < element.project_details.length; i++) {
                let roleItem = element.project_details[i];
                for (let m = 0; m < datesArray.length; m++) {
                    let date = datesArray[m]
                    if (roleItem.dates.hasOwnProperty(date) && roleItem.dates[date] !== 0) {
                        let projectCode
                        if (this.state.type === 'week') {
                            projectCode = roleItem.crm_project_code ? roleItem.crm_project_code + ` (Qty:${roleItem.dates[date]}) [${disciplineDateObj[date]}]` : roleItem.crm_name;
                        } else {
                            projectCode = roleItem.crm_project_code ? roleItem.crm_project_code + ` (Qty:${roleItem.dates[date]})` : roleItem.crm_name;
                        }
                        if (weeks.indexOf(date) === -1) {
                            weeks.push(date);
                            weekdata.push({ name: [roleItem.crm_name], project_code: [[roleItem.crm_project_code ? projectCode : roleItem.crm_name]], crmId: [roleItem.crm], crm_color_code: [roleItem.crm_color_code], leave: [element.emp_leave[date]] })
                        } else {
                            if (weekdata[weeks.indexOf(date)]['name'] !== "") {
                                weekdata[weeks.indexOf(date)]['name'].push(roleItem.crm_name)
                                weekdata[weeks.indexOf(date)]['project_code'].push(roleItem.crm_project_code ? projectCode : roleItem.crm_name)
                                weekdata[weeks.indexOf(date)]['crmId'].push(roleItem.crm)
                                weekdata[weeks.indexOf(date)]['crm_color_code'].push(roleItem.crm_color_code)
                                weekdata[weeks.indexOf(date)]['leave'] = element.emp_leave[date]
                            } else if (weekdata[weeks.indexOf(date)]['name'] === "") {
                                weekdata[weeks.indexOf(date)]['name'].push(this.state.projectObj[roleItem.crm_name])
                                weekdata[weeks.indexOf(date)]['project_code'].push(roleItem.crm_project_code ? projectCode : roleItem.crm_name)
                                weekdata[weeks.indexOf(date)]['crmId'].push(roleItem.crm)
                                weekdata[weeks.indexOf(date)]['crm_color_code'].push(roleItem.crm_color_code)
                                weekdata[weeks.indexOf(date)]['leave'] = element.emp_leave[date]
                            }
                        }
                    }
                    else {
                        if (weeks.indexOf(date) === -1) {
                            weeks.push(date);
                            weekdata.push({ name: [], crmId: [], project_code: [], crm_color_code: [], leave: element.emp_leave[date] })
                        }
                    }
                }
            }
            element['weeks'] = weeks;
            element['weekdata'] = weekdata
            if (element.weekdata.length > 0) {
                if ((!element.end_date ? true : moment(element.end_date).isAfter(moment().format()))) {
                    // filterEmp.push(element)
                }
            }

            let columns = []
            for (let i = 0; i < datesArray.length; i++) {
                let newObj = {
                    title: type === "week" ? moment(datesArray[i], 'DD/MM/YYYY').format('DD MMM') : type === "month" ? moment(datesArray[i]).format('MMM YYYY') : type === "quarter" ? datesArray[i] : '',
                    field: datesArray[i],
                    type: 'number',
                    width: 150,
                    sorting: false,
                    editable: 'never',
                    filtering: false
                }
                columns.push(newObj)
            }
            finalColumns = columns
        }
        allRoles.sort((a, b) => a.first_name.localeCompare(b.first_name));
        splittedRoleEmployees.push({ role: 0, allEmpCopy: allRoles, allEmp: allRoles, columns: finalColumns, allMonths: allMonths })
        this.setState({ splittedRoleEmployees, reportedRoles, templateRoles, isLoading: false, isLoading1: false, })
    }

    fetchOps() {
        this.setState({ isLoading1: true, addEmpDisabled: true })

        let selectedRolesIds = [];
        this.state.selectedRole.forEach((role) => {
            selectedRolesIds.push(role.id);
        });

        let selectedSubSectorsIds = [];
        this.state.selectedSubSector.forEach((sector) => {
            selectedSubSectorsIds.push(sector.id);
        });

        let selectedOwnerRegionIds = [];
        this.state.selectedOwnerRegion.forEach((region) => {
            selectedOwnerRegionIds.push(region.id);
        });

        let selectedOwnerDeliveryIds = [];
        this.state.selectedOwnerDelivery.forEach((odu) => {
            selectedOwnerDeliveryIds.push(odu.id);
        });

        let selectedRoleGroupIds = [];
        this.state.selectedRoleGroup.forEach((rg) => {
            selectedRoleGroupIds.push(rg.id);
        });



        let roles_sectors_regions_OD_uri = '';
        if (this.state.type === 'week') {
            roles_sectors_regions_OD_uri = '/api/prp/rolenew/get_staff_location_data/?archive_reason=0&'
        } else if (this.state.type === 'month') {
            roles_sectors_regions_OD_uri = '/api/prp/rolenew/get_staff_location_data/?archive_reason=0&change_report_type=month&'
        } else if (this.state.type === 'quarter') {
            roles_sectors_regions_OD_uri = '/api/prp/rolenew/get_staff_location_data/?archive_reason=0&change_report_type=quarter&'
        }
        if (selectedRolesIds.length > 0) {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `role=${selectedRolesIds.join()}&`
        }
        if (selectedSubSectorsIds.length > 0) {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `sector=${selectedSubSectorsIds.join()}&`
        }
        if (selectedOwnerRegionIds.length > 0) {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `region=${selectedOwnerRegionIds.join()}&`
        }
        if (selectedOwnerDeliveryIds.length > 0) {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `delivery=${selectedOwnerDeliveryIds.join()}&`
        }
        if (selectedRoleGroupIds.length > 0) {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `role_group=${selectedRoleGroupIds.join()}&`
        }

        if (this.state.selectedDivision.length > 0) {
            let divisionId = this.state.selectedDivision.map(div => div.id).join(',');
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `division=${divisionId}&`
        }

        if (this.state.selectedEmployee?.id) {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `emp=${this.state.selectedEmployee.id}`
        }
        if (roles_sectors_regions_OD_uri[roles_sectors_regions_OD_uri.length - 1] === "&") {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri.substring(0, roles_sectors_regions_OD_uri.length - 1)
        }

        if (this.state.selectedStartDate && this.state.selectedEndDate) {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `&from_date=${moment(this.state.selectedStartDate).format('YYYY-MM-DD')}&to_date=${moment(this.state.selectedEndDate).format('YYYY-MM-DD')}`
        }

        roles_sectors_regions_OD_uri += '&is_active=True'

        Service.get(roles_sectors_regions_OD_uri, {
            headers: {
                Authorization: "Token " + token,
            }
        })
            .then(res => {
                let rolesss;
                if (this.state.selectedRole.length === 0) {
                    rolesss = [...this.state.allRoles]
                } else {
                    rolesss = [...this.state.selectedRole]
                }
                this.setState({
                    reportedRoles: rolesss,
                    addEmpDisabled: false,
                    responseData: res.data.data,
                    // isLoading: false,
                    // isLoading1: false,
                }, () => this.makeReport(res.data.data, res.data.all_dates, this.state.type))
            })
            .catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
                this.setState({ isLoading: false, isLoading1: false })
            })
    }

    exportExcel(type) {
        this.setState({ coffeeLoading: true, reportTypeDialog: false })
        let roles_sectors_regions_OD_uri = `/api/prp/rolenew/get_staff_location_data/?archive_reason=0&get_report=true&change_report_type=${type}&`;
        if (this.state.filter === 'crm') {
            if (this.state.selectedEmployee) {
                if (this.state.selectedEmployee.first_name !== 'Select Employee') {
                    roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `emp=${this.state.selectedEmployee.id}&`
                }
            }
            if (this.state.selectedCrm) {
                if (this.state.selectedCrm.id) {
                    roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `crm=${this.state.selectedCrm.id}&`
                }
            }
            let selectedRoleGrpIds = [];
            this.state.selectedRoleGrp.forEach((rg) => {
                selectedRoleGrpIds.push(rg.id);
            });
            if (selectedRoleGrpIds.length > 0) {
                roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `role_group=${selectedRoleGrpIds.join(',')}&`
            }

        } else {
            let selectedRolesIds = [];
            this.state.selectedRole.forEach((role) => {
                selectedRolesIds.push(role.id);
            });

            let selectedSubSectorsIds = [];
            this.state.selectedSubSector.forEach((sector) => {
                selectedSubSectorsIds.push(sector.id);
            });

            let selectedOwnerRegionIds = [];
            this.state.selectedOwnerRegion.forEach((region) => {
                selectedOwnerRegionIds.push(region.id);
            });

            let selectedOwnerDeliveryIds = [];
            this.state.selectedOwnerDelivery.forEach((odu) => {
                selectedOwnerDeliveryIds.push(odu.id);
            });

            let selectedRoleGroupIds = [];
            this.state.selectedRoleGroup.forEach((rg) => {
                selectedRoleGroupIds.push(rg.id);
            });


            let selectedDivisionIds = [];
            this.state.selectedDivision.forEach((div) => {
                selectedDivisionIds.push(div.id);
            });

            if (selectedRolesIds.length > 0) {
                roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `role=${selectedRolesIds.join()}&`
            }
            if (selectedSubSectorsIds.length > 0) {
                roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `sector=${selectedSubSectorsIds.join()}&`
            }
            if (selectedOwnerRegionIds.length > 0) {
                roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `region=${selectedOwnerRegionIds.join()}&`
            }
            if (selectedOwnerDeliveryIds.length > 0) {
                roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `delivery=${selectedOwnerDeliveryIds.join()}&`
            }
            if (selectedRoleGroupIds.length > 0) {
                roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `role_group=${selectedRoleGroupIds.join()}&`
            }
            if (selectedDivisionIds.length > 0) {
                roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `division=${selectedDivisionIds.join()}&`
            }
        }


        if (roles_sectors_regions_OD_uri[roles_sectors_regions_OD_uri.length - 1] === "&") {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri.substring(0, roles_sectors_regions_OD_uri.length - 1)
        }

        if (this.state.selectedStartDate && this.state.selectedEndDate) {
            roles_sectors_regions_OD_uri = roles_sectors_regions_OD_uri + `&from_date=${moment(this.state.selectedStartDate).format('YYYY-MM-DD')}&to_date=${moment(this.state.selectedEndDate).format('YYYY-MM-DD')}`
        }

        roles_sectors_regions_OD_uri += '&is_active=True'

        Service.get(roles_sectors_regions_OD_uri, {
            headers: {
                Authorization: "Token " + token,
            }
        })
            .then(res => {
                this.setState({
                    excelExportDialog: true,
                    coffeeLoading: false
                })
            })
            .catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
                this.setState({ isLoading: false, isLoading1: false, coffeeLoading: false })
            })
    }

    filterCRM() {
        if (this.state.selectedRole.length > 0 || this.state.selectedOwnerRegion.length > 0 || this.state.selectedSubSector.length > 0 || this.state.selectedOwnerDelivery.length > 0 || this.state.selectedRoleGroup.length > 0 || this.state.selectedRoleGrp.length > 0 || this.state.selectedDivision.length > 0) {
            this.fetchOps()
        } else {
            this.props.enqueueSnackbar('Please select atleast one of the filters!', { variant: 'warning' })
        }
    }

    reRenderingEmpLocation() {
        this.setState({ searchRerenders: true });
    }

    handleOwnerDeliveryChange = (e, value) => {
        let searchParams = new URLSearchParams(window.location.search)
        if (value.length > 0) {
            let selectedOwnerDeliveryIds = [];
            value.forEach((od) => {
                selectedOwnerDeliveryIds.push(od.id)
            })
            if (searchParams.has("selectedOwnerDelivery")) {
                searchParams.set("selectedOwnerDelivery", selectedOwnerDeliveryIds.join(","))
            } else {
                searchParams.append("selectedOwnerDelivery", selectedOwnerDeliveryIds.join(","))
            }

        } else if (value.length === 0) {
            searchParams.delete("selectedOwnerDelivery")

        }
        // sessionStorage.setItem("lasturi", url + '?' + searchParams.toString())
        // window.history.pushState({ id: window.location.href }, '', url + '?' + searchParams.toString())
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);

        this.setState({ selectedOwnerDelivery: value })
    }

    handleSubSectorChange = (e, value) => {
        let searchParams = new URLSearchParams(window.location.search)
        if (value.length > 0) {
            let selectedSubSectorIds = [];
            value.forEach((subSector) => {
                selectedSubSectorIds.push(subSector.id)
            })
            if (searchParams.has("selectedSubSector")) {
                searchParams.set("selectedSubSector", selectedSubSectorIds.join(","))
            } else {
                searchParams.append("selectedSubSector", selectedSubSectorIds.join(","))
            }

        } else if (value.length === 0) {
            searchParams.delete("selectedSubSector")
        }
        // sessionStorage.setItem("lasturi", url + '?' + searchParams.toString())
        // window.history.pushState({ id: window.location.href }, '', url + '?' + searchParams.toString())
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);


        this.setState({ selectedSubSector: value })
    }

    handleRoleChange = (e, value) => {
        let searchParams = new URLSearchParams(window.location.search)
        if (value.length > 0) {
            let selectedRolesIds = [];
            value.forEach((region) => {
                selectedRolesIds.push(region.id)
            })
            if (searchParams.has("role")) {
                searchParams.set("role", selectedRolesIds.join(","))
            } else {
                searchParams.append("role", selectedRolesIds.join(","))
            }

        } else if (value.length === 0) {
            searchParams.delete("role")

        }
        // sessionStorage.setItem("lasturi", url + '?' + searchParams.toString())
        // window.history.pushState({ id: window.location.href }, '', url + '?' + searchParams.toString())
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);

        this.setState({ selectedRole: value, reportedRoles: value })
    }

    handleRoleGroupChange = (e, value) => {
        let searchParams = new URLSearchParams(window.location.search)
        if (value.length > 0) {
            let selectedRoleGroupIds = [];
            value.forEach((region) => {
                selectedRoleGroupIds.push(region.id)
            })
            if (searchParams.has("roleGroup")) {
                searchParams.set("roleGroup", selectedRoleGroupIds.join(","))
            } else {
                searchParams.append("roleGroup", selectedRoleGroupIds.join(","))
            }
        } else if (value.length === 0) {
            searchParams.delete("roleGroup")
        }
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;
        window.history.pushState(null, '', newRelativePathQuery);
        this.setState({ selectedRoleGroup: value })
    }

    handleRoleGrpChange = (e, value) => {
        let searchParams = new URLSearchParams(window.location.search)
        if (value.length > 0) {
            let selectedRoleGrpIds = [];
            value.forEach((region) => {
                selectedRoleGrpIds.push(region.id)
            })
            if (searchParams.has("roleGrp")) {
                searchParams.set("roleGrp", selectedRoleGrpIds.join(","))
            } else {
                searchParams.append("roleGrp", selectedRoleGrpIds.join(","))
            }
        } else if (value.length === 0) {
            searchParams.delete("roleGrp")
        }
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;
        window.history.pushState(null, '', newRelativePathQuery);
        this.setState({ selectedRoleGrp: value })
    }

    handleCrmChange(e, value) {
        let searchParams = new URLSearchParams(window.location.search)
        if (value) {
            // let selectedCrmIds = [];
            // value.forEach((crm) => {
            //     selectedCrmIds.push(crm.id)
            // })
            if (searchParams.has("crm")) {
                searchParams.set("crm", value.id)
            } else {
                searchParams.append("crm", value.id)
            }
            let allocationData = { prj: { crm: value.id, crm_name: value.name } }
            this.setState({ allocationData })
        } else {
            this.setState({ allocationData: null })
            searchParams.delete("crm")
        }

        // sessionStorage.setItem("lasturi", url + '?' + searchParams.toString())
        // window.history.pushState({ id: window.location.href }, '', url + '?' + searchParams.toString())
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);

        this.setState({ selectedCrm: value })
    }

    handleEmployeeChange(e, value) {
        let searchParams = new URLSearchParams(window.location.search)
        if (value) {
            // let selectedCrmIds = [];
            // value.forEach((crm) => {
            //     selectedCrmIds.push(crm.id)
            // })
            if (searchParams.has("employee")) {
                searchParams.set("employee", value.id)
            } else {
                searchParams.append("employee", value.id)
            }
            this.setState({ addEmpDisabled: true })
        } else {
            this.setState({ addEmpDisabled: false })
            searchParams.delete("employee")
        }

        // sessionStorage.setItem("lasturi", url + '?' + searchParams.toString())
        // window.history.pushState({ id: window.location.href }, '', url + '?' + searchParams.toString())
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);

        this.setState({ selectedEmployee: value })

    }

    handleRegionChange = (e, value) => {
        let searchParams = new URLSearchParams(window.location.search)
        if (value.length > 0) {
            let selectedRegionIds = [];
            value.forEach((region) => {
                selectedRegionIds.push(region.id)
            })
            if (searchParams.has("selectedOwnerRegion")) {
                searchParams.set("selectedOwnerRegion", selectedRegionIds.join(","))
            } else {
                searchParams.append("selectedOwnerRegion", selectedRegionIds.join(","))
            }

        } else if (value.length === 0) {
            searchParams.delete("selectedOwnerRegion")

        }

        // sessionStorage.setItem("lasturi", url + '?' + searchParams.toString())
        // window.history.pushState({ id: window.location.href }, '', url + '?' + searchParams.toString())

        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);


        this.setState({ selectedOwnerRegion: value })
    }

    openRole = (roleIndex) => { this.setState({ showRole: (!this.state.showRole), showRoleIndex: roleIndex }) }

    getReport() {
        this.setState({ isLoading1: true }, () => {
            if (this.state.selectedCrm?.id || this.state.selectedEmployee?.id || this.state.selectedRoleGrp.length > 0) {
                this.setState({ isLoading: true, splittedRoleEmployees: [] }, () => {
                    this.getProjectsEmployees()
                })
            } else if (this.state.selectedRole.length > 0 || this.state.selectedOwnerRegion.length > 0 || this.state.selectedSubSector.length > 0 || this.state.selectedOwnerDelivery.length > 0 || this.state.selectedRoleGroup.length > 0) {
                this.filterCRM()
            } else {
                this.fetchOps()
            }
        })
    }

    handleDateChange1 = (d) => {
        this.setState({ selectedStartDate: d })
    }

    handleDateChange2 = (d) => {
        this.setState({ selectedEndDate: d })
    }

    prev6months = () => {
        if (!this.state.selectedStartDate || !this.state.selectedEndDate) {
            this.setState({ selectedStartDate: moment().subtract(2, 'months').startOf('month'), selectedEndDate: moment().add(6, 'months').endOf('month') }, () => {
                this.setState({ selectedStartDate: moment(this.state.selectedStartDate).subtract(6, 'months'), selectedEndDate: moment(this.state.selectedEndDate).subtract(6, 'months') }, () => {
                    this.getReports()
                })
            })
        } else {
            this.setState({ selectedStartDate: moment(this.state.selectedStartDate).subtract(6, 'months'), selectedEndDate: moment(this.state.selectedEndDate).subtract(6, 'months') }, () => {
                this.getReports()
            })
        }

    }

    next6months = () => {
        if (!this.state.selectedStartDate || !this.state.selectedEndDate) {
            this.setState({ selectedStartDate: moment().subtract(2, 'months').startOf('month'), selectedEndDate: moment().add(6, 'months').endOf('month') }, () => {
                this.setState({ selectedStartDate: moment(this.state.selectedStartDate).add(6, 'months'), selectedEndDate: moment(this.state.selectedEndDate).add(6, 'months') }, () => {
                    this.getReports(this.state.selectedStartDate, this.state.selectedEndDate)
                })
            })
        } else {
            this.setState({ selectedStartDate: moment(this.state.selectedStartDate).add(6, 'months'), selectedEndDate: moment(this.state.selectedEndDate).add(6, 'months') }, () => {
                this.getReports(this.state.selectedStartDate, this.state.selectedEndDate)
            })
        }
    }

    getReports() {
        if (!this.state.selectedEndDate || !this.state.selectedStartDate) {
            this.props.enqueueSnackbar("Please select the months!", {
                variant: "warning",
            });
        } else {
            this.getReport()
        }
    }

    getDialogSize = (size) => {
        this.setState({ allocationDialogSize: size })
    }

    closeDialog = () => {
        this.setState({ allocationDialog: false, allocationDialogSize: "xs", allocationData: null }, () => {
            if (this.state.selectedCrm?.id || this.state.selectedEmployee?.id || this.state.selectedRoleGrp.length > 0) {
                this.setState({ isLoading: true, splittedRoleEmployees: [] }, () => {
                    this.getProjectsEmployees()
                })
            } else if (this.state.selectedRole.length > 0 || this.state.selectedOwnerRegion.length > 0 || this.state.selectedSubSector.length > 0 || this.state.selectedOwnerDelivery.length > 0 || this.state.selectedRoleGroup.length > 0) {
                this.filterCRM()
            } else {
                this.fetchOps()
            }
        })
    }

    addAllocation = (emp, prj) => {
        let allocationData = { emp: emp, prj: prj }
        this.setState({ allocationData: allocationData }, () => {
            this.setState({ allocationDialog: true, allocationDialogSize: "xs" })
        })
    }

    roleGetReport() {
        let searchParams = new URLSearchParams(window.location.search)
        if (searchParams.has("crm")) {
            searchParams.delete("crm")
        }
        if (searchParams.has("employee")) {
            searchParams.delete("employee")
        }
        if (searchParams.has("roleGrp")) {
            searchParams.delete("roleGrp")
        }
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);
        this.setState({
            selectedCrm: { name: '', id: '' },
            selectedEmployee: { first_name: 'Select Employee', last_name: '', id: '' },
            selectedRoleGrp: [],
            showRole: false, showRoleIndex: null, splittedRoleEmployees: []
        }, () => {
            this.filterCRM()
        })
    }

    crmGetReport() {
        let searchParams = new URLSearchParams(window.location.search)
        if (searchParams.has("selectedOwnerDelivery")) {
            searchParams.delete("selectedOwnerDelivery")
        }
        if (searchParams.has("selectedSubSector")) {
            searchParams.delete("selectedSubSector")
        }
        if (searchParams.has("role")) {
            searchParams.delete("role")
        }
        if (searchParams.has("selectedOwnerRegion")) {
            searchParams.delete("selectedOwnerRegion")
        }
        if (searchParams.has("roleGroup")) {
            searchParams.delete("roleGroup")
        }
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);
        if (this.state.selectedCrm?.id || this.state.selectedEmployee?.id || this.state.selectedRoleGrp.length > 0) {
            this.setState({
                splittedRoleEmployees: [],
                selectedSubSector: [],
                selectedRole: [],
                selectedOwnerDelivery: [],
                selectedOwnerRegion: [],
                selectedRoleGroup: [],
            }, () => {
                this.getProjectsEmployees()
            })
        } else {
            this.props.enqueueSnackbar('Please select atleast one of the filters!', { variant: 'warning' })
        }
    }

    handleChange = (event) => {
        this.setState({ type: event.target.value }, () => {
            if (this.state.type === 'month') {
                let endDate = moment(this.state.selectedStartDate).add(3, 'years')
                this.setState({ selectedEndDate: endDate }, () => {
                    if (this.state.toggleView === 'crm') {
                        this.getProjectsEmployees()
                    } else {
                        this.fetchOps()
                    }
                })
            } else if (this.state.type === 'quarter') {
                let endDate = moment(this.state.selectedStartDate).add(5, 'years')
                this.setState({ selectedEndDate: endDate }, () => {
                    if (this.state.toggleView === 'crm') {
                        this.getProjectsEmployees()
                    } else {
                        this.fetchOps()
                    }
                })
            } else {
                let endDate = moment(this.state.selectedStartDate).add(9, 'months')
                this.setState({ selectedEndDate: endDate }, () => {
                    if (this.state.toggleView === 'crm') {
                        this.getProjectsEmployees()
                    } else {
                        this.fetchOps()
                    }
                })
            }

        });
    }

    decreaseZoom = () => {
        let zoom = (Number(this.state.zoom) - 0.1).toFixed(1);
        if (zoom < 0.5) return;
        this.setState({ zoom: zoom })
    }

    increaseZoom = () => {
        let zoom = (Number(this.state.zoom) + 0.1).toFixed(1);
        if (zoom > 1.5) return;
        this.setState({ zoom: zoom })
    }

    screenSizeCheck() {
        if (window.innerWidth > 1600) {
            return true
        } else {
            return false
        }
    }

    changeView = (view) => {
        let searchParams = new URLSearchParams(window.location.search)
        searchParams.delete("selectedOwnerDelivery")
        searchParams.delete("selectedSubSector")
        searchParams.delete("role")
        searchParams.delete("selectedOwnerRegion")
        searchParams.delete("roleGroup")
        searchParams.delete("crm")
        searchParams.delete("employee")
        searchParams.delete("roleGrp")
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;

        window.history.pushState(null, '', newRelativePathQuery);
        this.setState({
            toggleView: view,
            selectedCrm: { name: '', id: '' },
            selectedEmployee: { first_name: 'Select Employee', last_name: '', id: '' },
            selectedRole: [],
            selectedOwnerRegion: [],
            selectedSubSector: [],
            selectedOwnerDelivery: [],
            selectedRoleGroup: [],
            showRole: false,
            showRoleIndex: null,
            splittedRoleEmployees: [],
            responseData: [],
            selectedRoleGrp: [],
        })
    }

    changeViewParent(view) {
        if (this.props.changeViewParent) {
            this.props.changeViewParent(view)
        }
    }

    scrolltoTop() {
        if (this.topRef.current) {
            this.topRef.current.scrollIntoView({ behavior: "smooth" })
            // this.setState({ scrollTop: false })
        }
    }

    handleDivisionChange = (e, value) => {
        let searchParams = new URLSearchParams(window.location.search)
        let id = ''
        if (value.length > 0) {
            id = value.map(div => div.id).join(',')
        } else {
            id = ''
        }
        if (id) {
            if (searchParams.has("division")) {
                searchParams.set("division", id)
            } else {
                searchParams.append("division", id)
            }
        } else {
            searchParams.delete("division")
        }
        let hash = window.location.hash
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString() + hash;
        window.history.pushState(null, '', newRelativePathQuery);
        this.setState({ selectedDivision: value })
    }

    openBulkUpdateDialog = () => {
        this.setState({ bulkUpdateDialog: true, bulkUpdate: { ...initialBulkUpdateState } })
    }

    closeBulkUpdateDialog = () => {
        this.setState({
            bulkUpdateDialog: false,
            bulkUpdate: { ...initialBulkUpdateState }
        })
    }

    handleBulkUpdateAdd = () => {
        var bulkUpdate = { ...this.state.bulkUpdate }
        const taskCategory = `${bulkUpdate.taskCategory || ''}`.trim()
        var fields = ''
        if (!bulkUpdate.employee) {
            fields += 'Employee'
        }
        if (!bulkUpdate.fromDate) {
            fields += !fields ? 'From Date' : ', From Date'
        }
        if (!bulkUpdate.toDate) {
            fields += !fields ? 'To Date' : ', To Date'
        }

        if (!taskCategory) {
            fields += !fields ? 'Task Category' : ', Task Category'
        }

        if (!bulkUpdate.comments) {
            fields += !fields ? 'Comments' : ', Comments'
        }

        if (!bulkUpdate.quantity) {
            fields += !fields ? 'Quantity' : ', Quantity'
        }
        if (fields) {
            this.props.enqueueSnackbar(`Please fill the following fields: ${fields}`, { variant: 'warning' })
        } else {
            this.setState({ bulkLoading: true })
            Service.post('/api/ptd/employees/leave/bulk_allocate_leave/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: {
                    emp_id: bulkUpdate.employee.employee_id,
                    from_date: moment(bulkUpdate.fromDate).format('DD/MM/YYYY'),
                    to_date: moment(bulkUpdate.toDate).format('DD/MM/YYYY'),
                    other_tasks: taskCategory,
                    comments: bulkUpdate.comments,
                    quantity: bulkUpdate.quantity
                },
            }).then(() => {
                this.setState({ bulkLoading: false });
                this.props.enqueueSnackbar('Bulk update leaves added.', { variant: 'success' })
                this.closeBulkUpdateDialog()
                if (this.state.toggleView === 'crm') {
                    this.getProjectsEmployees()
                } else {
                    this.fetchOps()
                }
            }).catch((error) => {
                console.log(error);
                this.setState({ bulkLoading: false });
                if (error && error.status === 406) {
                    this.props.enqueueSnackbar(error.data.message, { variant: 'warning' })
                } else {
                    this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' })
                }
            });
        }
    }


    render() {
        // const classes = this.props.classes;

        const handleClose = () => {
            this.setState({ allocationDialog: false, allocationDialogSize: "xs", allocationData: null }, () => {
                if (this.state.selectedCrm?.id) {
                    let allocationData = { prj: { crm: this.state.selectedCrm.id, crm_name: this.state.selectedCrm.name } }
                    this.setState({ allocationData })
                }
            })
        };

        const bulkUpdate = this.state.bulkUpdate;

        return (
            <div>
                {this.state.isLoading ? <RotateCircleLoading color={getPrimaryColor()} /> :
                    <Box display={'flex'} flexDirection={'column'} justifyContent={'center'}>
                        {this.state.toggleView === 'role' ?
                            <Grid container spacing={1} style={{ marginBottom: '20px' }} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                                <Grid item xs={1.5}>
                                    <Autocomplete
                                        multiple
                                        id="sub-sector"
                                        limitTags={1}
                                        options={this.state.allSubSectors}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) => option.name}
                                        onChange={(e, value) => this.handleSubSectorChange(e, value)}
                                        value={this.state.selectedSubSector}
                                        size="small"
                                        renderOption={(option, { selected }) => (
                                            <React.Fragment>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.name}
                                            </React.Fragment>
                                        )}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="outlined" label="Sector" placeholder="Sector" />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={2}>
                                    <Autocomplete
                                        multiple
                                        id="owner-region-sector"
                                        limitTags={1}
                                        options={this.state.allOwnerRegions}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) => option.name}
                                        onChange={(e, value) => this.handleRegionChange('selectedOwnerRegion', value)}
                                        value={this.state.selectedOwnerRegion}
                                        size="small"
                                        renderOption={(option, { selected }) => (
                                            <React.Fragment>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.name}
                                            </React.Fragment>
                                        )}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="outlined" label="Region" placeholder="Region" />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={1.5}>
                                    <Autocomplete
                                        multiple
                                        id="owner-delivery-unit"
                                        limitTags={1}
                                        options={this.state.allOwnerDeliveryUnits}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) => option.name}
                                        onChange={(e, value) => this.handleOwnerDeliveryChange(e, value)}
                                        value={this.state.selectedOwnerDelivery}
                                        size="small"
                                        renderOption={(option, { selected }) => (
                                            <React.Fragment>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.name}
                                            </React.Fragment>
                                        )}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="outlined" label="Operations Lead" placeholder="Operations Lead" />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={2}>
                                    <Autocomplete
                                        multiple
                                        id="roles"
                                        limitTags={1}
                                        options={this.state.allRoles}
                                        getOptionLabel={(option) => option.job_roles}
                                        onChange={(e, value) => this.handleRoleChange(e, value)}
                                        disableCloseOnSelect
                                        value={this.state.selectedRole}
                                        size="small"
                                        renderOption={(option, { selected }) => (
                                            <React.Fragment>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.job_roles}
                                            </React.Fragment>
                                        )}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="outlined" label="Role" placeholder="Role" />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={1.5}>
                                    <Autocomplete
                                        multiple
                                        id="roleGroup"
                                        limitTags={1}
                                        options={this.state.roleGroup}
                                        getOptionLabel={(option) => option.name}
                                        onChange={(e, value) => this.handleRoleGroupChange(e, value)}
                                        disableCloseOnSelect
                                        value={this.state.selectedRoleGroup}
                                        size="small"
                                        renderOption={(option, { selected }) => (
                                            <React.Fragment>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.name}
                                            </React.Fragment>
                                        )}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="outlined" label="Role Group" placeholder="Role Group" />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={1.5}>
                                    <Autocomplete
                                        multiple
                                        id='division'
                                        options={this.state.allDivisions ? this.state.allDivisions : []}
                                        getOptionLabel={(option) => option.name}
                                        onChange={(e, value) => this.handleDivisionChange(e, value)}
                                        disableCloseOnSelect
                                        value={this.state.selectedDivision}
                                        size="small"
                                        renderOption={(option, { selected }) => (
                                            <React.Fragment>
                                                <Checkbox

                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.name}
                                            </React.Fragment>
                                        )}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="outlined" label="Division" placeholder="Division" />
                                        )}
                                    />
                                </Grid>


                                <Grid item xs={2}>
                                    <Button variant="contained" size='small' color="primary" onClick={() => this.roleGetReport()}> Get Report</Button>
                                    <Button variant="contained" size='small' style={{ marginLeft: "2px" }} color="primary" onClick={() => { this.setState({ reportTypeDialog: true, filter: 'role' }) }}>
                                        Excel Export
                                    </Button>
                                </Grid>
                            </Grid> :
                            <Grid container justifyContent="center" alignItems={'center'} spacing={2} style={{ marginBottom: '20px' }}>
                                <Grid item xs={3}>
                                    <Autocomplete
                                        // multiple
                                        id="Crm"
                                        options={this.state.allProjects}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) => option.name}
                                        onChange={(e, value) => this.handleCrmChange(e, value)}
                                        value={this.state.selectedCrm}
                                        size="small"
                                        renderOption={(option, { selected }) => (
                                            <React.Fragment>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.name}
                                            </React.Fragment>
                                        )}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="outlined" label="Crm" placeholder="Crm" />
                                        )} />

                                </Grid>
                                <Grid item xs={2}>
                                    <Autocomplete
                                        multiple
                                        id="roleGroup"
                                        options={this.state.roleGroup}
                                        getOptionLabel={(option) => option.name}
                                        onChange={(e, value) => this.handleRoleGrpChange(e, value)}
                                        disableCloseOnSelect
                                        value={this.state.selectedRoleGrp}
                                        size="small"
                                        renderOption={(option, { selected }) => (
                                            <React.Fragment>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.name}
                                            </React.Fragment>
                                        )}
                                        renderInput={(params) => (
                                            <TextField {...params} variant="outlined" label="Role Group" placeholder="Role Group" />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <Autocomplete
                                        // multiple
                                        id="Employee"
                                        options={this.state.allEmp}
                                        disableCloseOnSelect
                                        getOptionLabel={(option) => option.first_name + ' ' + option.last_name}
                                        onChange={(e, value) => this.handleEmployeeChange(e, value)}
                                        value={this.state.selectedEmployee}
                                        size="small"
                                        renderOption={(option, { selected }) => (
                                            <React.Fragment>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.first_name + ' ' + option.last_name}
                                            </React.Fragment>
                                        )}
                                        renderInput={(params) => (

                                            <TextField {...params} variant="outlined" label="Employee" placeholder="Employee" />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <Button variant="contained" size='small' color="primary" onClick={() => this.crmGetReport()}> Get Report</Button>
                                    <Button variant="contained" size='small' style={{ marginLeft: "5px" }} color="primary" onClick={() => { this.setState({ reportTypeDialog: true, filter: 'crm' }) }}>
                                        Excel Export
                                    </Button>
                                </Grid>
                            </Grid>}

                        {this.state.splittedRoleEmployees.length > 0 ?
                            <Box display='flex' flexDirection={'row'} mb={1}>
                                <Box flexGrow={1} display='flex' flexDirection={'row'} alignItems={'center'}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <DatePicker
                                            variant="dialog"
                                            openTo="month"
                                            views={["month", "year"]}
                                            label="Start Month"
                                            maxDate={this.state.selectedEndDate ? moment(this.state.selectedEndDate).subtract(1, 'month') : undefined}
                                            autoOk={true}
                                            value={this.state.selectedStartDate}
                                            onChange={this.handleDateChange1}
                                            style={{ marginRight: '5px' }}
                                        />
                                        <DatePicker
                                            variant="dialog"
                                            openTo="month"
                                            views={["month", "year"]}
                                            label="End Month"
                                            minDate={this.state.selectedStartDate ? moment(this.state.selectedStartDate).add(1, 'month') : undefined}
                                            autoOk={true}
                                            value={this.state.selectedEndDate}
                                            onChange={this.handleDateChange2}
                                            style={{ marginRight: '5px' }}
                                        />
                                    </MuiPickersUtilsProvider>
                                    <Button variant="contained" color="primary"
                                        onClick={() => {
                                            this.getReports()
                                        }}> Get Report</Button>

                                </Box>
                                <Box display='flex' flexDirection={'row'} alignItems={'center'}>
                                    <TextField
                                        size='small'
                                        select
                                        variant='outlined'
                                        value={this.state.type}
                                        onChange={(e) => this.handleChange(e)}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        style={{ marginRight: '5px' }} >
                                        {['week', 'month', 'quarter'].map((option) => (
                                            <option key={option} value={option}>
                                                {option[0].toUpperCase() + option.slice(1)}
                                            </option>
                                        ))}
                                    </TextField>
                                    <Button
                                        size='small'
                                        variant="outlined"
                                        color="primary"
                                        onClick={this.openBulkUpdateDialog}
                                        style={{ marginRight: '5px' }}
                                    >
                                        Add Leaves
                                    </Button>
                                    {/* <Box display={'flex'} flexDirection={'row'} margin={'dense'}> */}
                                    <Button
                                        size='small'
                                        component="label"
                                        variant="outlined"
                                        tabIndex={-1}
                                        color="primary"
                                        startIcon={<PersonAddAlt1Icon />}
                                        onClick={() => this.setState({ allocationDialog: true })}
                                        disabled={this.state.addEmpDisabled}
                                    >
                                        Add Employee
                                    </Button>
                                    <Button size='small' variant="outlined" color="primary" onClick={() => this.prev6months()} style={{ marginLeft: "5px" }}>
                                        prev 6 months
                                    </Button>
                                    <Button size='small' variant="outlined" color="primary" onClick={() => this.next6months()} style={{ marginLeft: "5px" }}>
                                        next 6 months
                                    </Button>
                                    <ToggleButtonGroup
                                        exclusive
                                        aria-label="text alignment"
                                        style={{ marginLeft: "5px", float: 'right' }}
                                        size='small'
                                        color='primary'
                                    >
                                        <ToggleButton value="weeks" aria-label="by week" onClick={this.decreaseZoom} >
                                            <ZoomOut />
                                        </ToggleButton>
                                        <ToggleButton value="months" aria-label="by month" onClick={this.increaseZoom}>
                                            <ZoomIn />
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                </Box>
                                {/* </Box> */}
                            </Box> : null}
                        <ResourceLocationResults
                            isLoading1={this.state.isLoading1}
                            responseData={this.state.responseData}
                            splittedRoleEmployees={this.state.splittedRoleEmployees}
                            zoom={this.state.zoom}
                            selectedStartDate={this.state.selectedStartDate}
                            selectedEndDate={this.state.selectedEndDate}
                            rolesObj={this.state.rolesObj}
                            disciplineObj={this.state.disciplineObj}
                            projectObj={this.state.projectObj}
                            reportedRoles={this.state.reportedRoles}
                            allOtherTasks={this.state.allOtherTasks}
                            othertaskObject={this.state.othertaskObject}
                            allProjects={this.state.allProjects}
                            allRoles={this.state.allRoles}
                            liveOpportunities={this.state.liveOpportunities}
                            updateTheUpdatedSchedules={this.editedScheduleUIUpdate}
                            addAllocation={this.addAllocation}
                            type={this.state.type}
                            handleRefresh={this.handleRefresh}
                            roleContainerHeight={window.innerHeight - (screenSizeCheck() ? 220 : 252)}
                        />

                        <Dialog
                            fullWidth
                            maxWidth={this.state.allocationDialogSize}
                            open={this.state.allocationDialog}
                            TransitionComponent={Transition}
                            disableEnforceFocus>
                            <DialogTitle>
                                <Box display={'flex'} flexDirection={'row'} width={'100%'} alignItems={'center'}>
                                    <Typography variant="h6" component="div" style={{ flexGrow: 1 }}>
                                        {!this.state.allocationData ? "Add Employee" : this.state.allocationData?.emp ? ("Add Resource to " + this.state.allocationData?.emp?.first_name + " " + this.state.allocationData?.emp?.last_name) : this.state.allocationData?.prj?.crm_name ? ("Add Resource to " + this.state.allocationData?.prj?.crm_name) : "Add Resource"}
                                    </Typography>
                                    <IconButton onClick={handleClose}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                            </DialogTitle>
                            <DialogContent>
                                <UserAllocation
                                    isRemoveBackButton={true}
                                    type={'staff_location'}
                                    getDialogSize={this.getDialogSize}
                                    closeDialog={this.closeDialog}
                                    allocationData={this.state.allocationData}
                                    filters={
                                        {
                                            selectedRole: this.state.selectedRole,
                                            selectedSubSector: this.state.selectedSubSector,
                                            selectedOwnerRegion: this.state.selectedOwnerRegion,
                                            selectedOwnerDelivery: this.state.selectedOwnerDelivery,
                                            selectedRoleGroup: this.state.selectedRoleGroup,
                                            selectedCrm: this.state.selectedCrm,
                                            selectedEmployee: this.state.selectedEmployee,
                                            selectedRoleGrp: this.state.selectedRoleGrp
                                        }
                                    }
                                />
                            </DialogContent>
                        </Dialog>

                        <Dialog open={this.state.excelExportDialog} onClose={() => this.setState({ excelExportDialog: false })} >
                            <DialogContentText>
                                <Box margin={2}>
                                    The Report will be emailed to {user.email}
                                </Box>
                            </DialogContentText>
                            <DialogActions>
                                <Button onClick={() => this.setState({ excelExportDialog: false, reportTypeDialog: false })} color="primary">
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog open={this.state.reportTypeDialog} onClose={() => this.setState({ reportTypeDialog: false })} maxWidth='xs' fullWidth>
                            <DialogTitle>
                                <Box>
                                    <Typography>Select Report Type</Typography>
                                    <IconButton onClick={() => this.setState({ reportTypeDialog: false })} style={{ position: 'absolute', right: 8, top: 8, color: 'red' }}>
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                            </DialogTitle>
                            <DialogContentText>
                                <Box marginLeft={3}>
                                    Select the report type you want to generate.
                                </Box>
                            </DialogContentText>
                            <DialogActions>
                                <Button color='primary' size='small' onClick={() => { this.exportExcel('week') }}>Week</Button>
                                <Button color='primary' size='small' onClick={() => { this.exportExcel('month') }}>Month</Button>
                                <Button color='primary' size='small' onClick={() => { this.exportExcel('quarter') }}>Quarter</Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog maxWidth="sm" open={this.state.coffeeLoading} aria-labelledby="form-dialog-title">
                            <DialogContent>
                                <Box m={5} p={2}>
                                    <CoffeeLoading />
                                </Box>
                            </DialogContent>
                        </Dialog>

                        <Dialog
                            maxWidth="sm"
                            fullWidth
                            open={this.state.bulkUpdateDialog}
                        >
                            <DialogTitle>
                                <Box display={'flex'} flexDirection={'row'} width={'100%'} alignItems={'center'}>
                                    <IconButton onClick={this.closeBulkUpdateDialog} style={{ position: 'absolute', right: 8, top: 8, color: 'red' }}>
                                        <CloseIcon />
                                    </IconButton>
                                    <Typography variant="h6" component="div" >
                                        Add Leaves
                                    </Typography>
                                </Box>
                            </DialogTitle>
                            <DialogContent>
                                <Box mt={1} mb={2}>
                                    <Autocomplete
                                        id="bulk-update-employee"
                                        options={this.state.responseData || []}
                                        getOptionLabel={(option) => option ? `${option.first_name} ${option.last_name}` : ''}
                                        value={bulkUpdate.employee}
                                        onChange={(e, value) => {
                                            let bulkUpdate = { ...this.state.bulkUpdate };
                                            bulkUpdate.employee = value;
                                            this.setState({ bulkUpdate });
                                        }}
                                        size="small"
                                        renderInput={(params) => (
                                            <TextField {...params} variant="outlined" label="Employee" placeholder="Select Employee" />
                                        )}
                                    />
                                </Box>

                                <Box display={'flex'} flexDirection={'row'}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <DatePicker
                                            label="From Date"
                                            autoOk={true}
                                            value={bulkUpdate.fromDate}
                                            onChange={(d) => {
                                                let bulkUpdate = { ...this.state.bulkUpdate };
                                                bulkUpdate.fromDate = d;
                                                this.setState({ bulkUpdate });
                                            }}
                                            style={{ marginRight: '12px', width: '100%' }}
                                            variant="outlined"
                                        />
                                        <DatePicker
                                            label="To Date"
                                            autoOk={true}
                                            minDate={bulkUpdate.fromDate ? moment(bulkUpdate.fromDate) : undefined}
                                            value={bulkUpdate.toDate}
                                            onChange={(d) => {
                                                let bulkUpdate = { ...this.state.bulkUpdate };
                                                bulkUpdate.toDate = d;
                                                this.setState({ bulkUpdate });
                                            }}
                                            style={{ width: '100%' }}
                                            variant="outlined"
                                        />
                                    </MuiPickersUtilsProvider>
                                </Box>

                                <Box mt={2}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        select
                                        variant="outlined"
                                        value={bulkUpdate.taskCategory}
                                        label='Task Category'
                                        onChange={(e) => {
                                            let bulkUpdate = { ...this.state.bulkUpdate };
                                            bulkUpdate.taskCategory = e.target.value;
                                            this.setState({ bulkUpdate });
                                        }}
                                        SelectProps={{ native: true }}
                                    >
                                        <option value="" disabled hidden></option>
                                        {(this.state.allOtherTasks || []).map((task) => (
                                            <option key={task.id} value={task.id}>{task.name}</option>
                                        ))}
                                    </TextField>
                                </Box>

                                <Box mt={2}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        label="Comments"
                                        value={bulkUpdate.comments}
                                        onChange={(e) => {
                                            let bulkUpdate = { ...this.state.bulkUpdate };
                                            bulkUpdate.comments = e.target.value;
                                            this.setState({ bulkUpdate });
                                        }}
                                        multiline
                                        minRows={2}
                                    />
                                </Box>

                                <Box mt={2}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        select
                                        variant="outlined"
                                        label="Quantity"
                                        value={bulkUpdate.quantity}
                                        onChange={(e) => {
                                            let bulkUpdate = { ...this.state.bulkUpdate };
                                            bulkUpdate.quantity = e.target.value;
                                            this.setState({ bulkUpdate });
                                        }}
                                        SelectProps={{ native: true }}
                                    >
                                        <option value="0.5">0.5</option>
                                        <option value="1">1</option>
                                    </TextField>
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.closeBulkUpdateDialog} size='small' color="primary"
                                    variant="contained">
                                    Close
                                </Button>
                                <Button
                                    size='small'
                                    onClick={this.handleBulkUpdateAdd}
                                    color="primary"
                                    variant="contained"
                                    disabled={this.state.bulkLoading}
                                >
                                    {this.state.bulkLoading ? <CircularProgress size={24} /> : 'Add'}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </Box>
                }
            </div >)
    }
}

export default withSnackbar(ResourceLocation)